export default __webpack_public_path__ + "static/media/bio_text.7ca15271.png";